import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/services/pause";

export class GetDataFlowPauseServiceCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetDataFlowPauseServiceReqData = null;

    constructor(serviceName: string) {
        super();
        this.params = new GetDataFlowPauseServiceReqData(serviceName);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class GetDataFlowPauseServiceReqData {
    serviceName: string;

    constructor(serviceName: string) {
        this.serviceName = serviceName;
    }
}
